import React from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

/**
 * Honest product status — never blocks the UI.
 */
const SimulationStatusBanner = () => (
  <div
    className="galaxia-card px-4 py-3 flex items-start gap-3"
    role="status"
    aria-live="polite"
  >
    <InformationCircleIcon className="h-5 w-5 flex-shrink-0 mt-0.5" style={{ color: 'var(--galaxia-secondary-cta)' }} />
    <div className="text-sm" style={{ color: 'var(--galaxia-muted)' }}>
      <span className="font-medium" style={{ color: 'var(--galaxia-text)' }}>Simulation mode</span>
      {' — '}
      On-chain bridge operations are simulated until production RPC and contract addresses are configured.
      Galaxia ID SSO and wallet connection are optional for exploring the interface.
    </div>
  </div>
);

export default SimulationStatusBanner;
